module.exports = __webpack_public_path__ + "/styles/material-design-iconic-font.min.css";


//////////////////
// WEBPACK FOOTER
// ./app/styles/material-design-iconic-font.min.css
// module id = 642
// module chunks = 0